var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dd-m-extra--bookmark-box"},[_c('button',{staticClass:"dd-m-extra--bookmark-btn",class:{'is-active': _vm.mutableActive},attrs:{"type":"button"},on:{"click":function($event){return _vm.toggleBookmark()}}},[_c('i',{staticClass:"dd-m-icon icon-bookmark"}),_vm._v(" "),_c('i',{staticClass:"dd-m-icon icon-bookmark-filled"})])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-510f5e07","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/site/js/components/products/bookmark-btn.vue
// module id = 48
// module chunks = 0 4 5 6 7 8 9 10 13